import * as React from "react";

export const DownloadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="14" height="14.5" viewBox="0 0 17 16" fill="none" {...props}>
    <path d="M15.5 12V14.5H1.5V12M13.5 6L8.50002 11L3.5 6M8.5 11V0" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);
